import { useState } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface DeleteNotificationState {
  isLoading: boolean;
  error: string | null;
}

export const useNotificationDelete = () => {
  const [deleteState, setDeleteState] = useState<DeleteNotificationState>({
    isLoading: false,
    error: null,
  });

  const { fetchWithAuth } = useFetch();

  const deleteNotification = async (notificationId: string): Promise<boolean> => {
    setDeleteState({
      isLoading: true,
      error: null,
    });

    try {
      const response = await fetchWithAuth(`${API_CONFIG.BASE_URL}/notifications/${notificationId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao deletar notificação: ${response.status} - ${errorText}`);
      }

      setDeleteState(prev => ({
        ...prev,
        isLoading: false,
      }));

      return true;
    } catch (error) {
      setDeleteState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
      }));
      return false;
    }
  };

  const resetDeleteState = () => {
    setDeleteState({
      isLoading: false,
      error: null,
    });
  };

  return {
    deleteNotification,
    deleteState,
    resetDeleteState,
  };
};
